var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRoadCorridorTraffic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/hazard/road-corridor-traffic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/hazard/road-corridor-traffic",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9162168,48.4087499 L65.3655612,78.9909556 L74.900021,78.9909556 C76.0598051,78.9909556 77,79.9311505 77,81.0909346 L77,81.0909346 L77,87.9250947 L23,87.9250947 L23,81.0909346 C23,79.9311505 23.9401949,78.9909556 25.099979,78.9909556 L25.099979,78.9909556 L34.6445348,78.9909556 L40.0951413,48.4087499 L59.9162168,48.4087499 Z M57.4895043,34.8194629 L58.9887681,43.264811 L41.0114843,43.264811 L42.5233682,34.8194629 L57.4895043,34.8194629 Z M53.592428,13 L56.5594055,29.667321 L43.4395849,29.667321 L46.4191825,13 L53.592428,13 Z",
    id: "road-corridor-traffic",
    fill: "#1C7B97"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadCorridorTraffic);
export default __webpack_public_path__ + "static/media/road-corridor-traffic.c6758f7b.svg";
export { ForwardRef as ReactComponent };